import { ParsedPackage } from "../types";
import Button from "../../../components/ui/Button";

// Botones compactos, a medida de la cabecera del preset.
const chico: React.CSSProperties = {
  minHeight: 0,
  padding: "6px 10px",
  fontSize: 12,
  borderRadius: 10,
};

type PresetButtonsProps = {
  title: string;
  packages: ParsedPackage[];
  onAppendPackages: (packages: ParsedPackage[]) => void;
  onReplacePackages: (packages: ParsedPackage[]) => void;
};

function packageToLabel(item: ParsedPackage) {
  return `${item.weight}g · ${item.height}x${item.width}x${item.length}cm`;
}

export function PresetButtons({
  title,
  packages,
  onAppendPackages,
  onReplacePackages,
}: PresetButtonsProps) {
  return (
    <div
      style={{
        border: "1px solid var(--border-color)",
        borderRadius: 16,
        padding: 14,
        background: "var(--surface-secondary)",
      }}
    >
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          gap: 12,
          marginBottom: 12,
        }}
      >
        <h4
          style={{
            margin: 0,
            color: "var(--text-primary)",
            fontSize: 14,
            fontWeight: 700,
          }}
        >
          {title}
        </h4>

        <div style={{ display: "flex", gap: 8 }}>
          <Button
            variant="secondary"
            onClick={() => onAppendPackages(packages)}
            style={chico}
          >
            Agregar
          </Button>

          <Button
            variant="primary"
            onClick={() => onReplacePackages(packages)}
            style={chico}
          >
            Usar solo estos
          </Button>
        </div>
      </div>

      <div style={{ display: "grid", gap: 8 }}>
        {packages.map((item) => (
          <div
            key={`${item.label}-${item.weight}-${item.height}-${item.width}-${item.length}`}
            style={{
              display: "flex",
              justifyContent: "space-between",
              gap: 12,
              border: "1px solid var(--border-color)",
              borderRadius: 12,
              padding: "8px 10px",
              background: "var(--surface-primary)",
            }}
          >
            <div>
              <div
                style={{
                  color: "var(--text-primary)",
                  fontSize: 13,
                  fontWeight: 600,
                }}
              >
                {item.label || "Paquete"}
              </div>

              <div
                style={{
                  color: "var(--text-secondary)",
                  fontSize: 12,
                  marginTop: 2,
                }}
              >
                {packageToLabel(item)}
              </div>
            </div>

            <div
              style={{
                color: "var(--text-secondary)",
                fontSize: 12,
                textAlign: "right",
                whiteSpace: "nowrap",
              }}
            >
              <div>{item.volumeCm3.toLocaleString("es-AR")} cm³</div>
              <div>Aforo {item.aforoKg} kg</div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}